import script from "./PermissionItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./PermissionItem.vue?vue&type=script&setup=true&lang=ts"

import "./PermissionItem.vue?vue&type=style&index=0&id=49ed0a53&scooped=true&lang=css"

const __exports__ = script;

export default __exports__